import CustomerHome from '../dashboard/customers/tabs/home/CustomerHome';
import CustomerBankingOverview from '../dashboard/customers/tabs/banking/CustomerBankingOverview';
import CustomerAssets from '../dashboard/customers/tabs/assets/CustomerAssets';
import { useState } from 'react';
import CustomerSettings from '../dashboard/customers/tabs/settings/CustomerSettings';
import { Routes, Route } from 'react-router-dom';
import CustomerFinancesOverview from '../dashboard/customers/tabs/finances/CustomerFinancesOverview';
import DriversHome from '../dashboard/customers/tabs/drivers/DriversHome';
import DemoBrokerNetwork from './DemoBrokerNetwork';

interface DemoCustomerDashboardProps {
  userType: string;
  currentPage: string;
  currentTab: string;
  setCurrentTab: (tab: string) => void;
  subTab: string;
  setSubTab: (tab: string) => void;
  showSideNav: boolean;
  setShowSideNav: (show: boolean) => void;
}

function DemoCustomerDashboard({
  userType,
  currentPage,
  currentTab,
  setCurrentTab,
  subTab,
  setSubTab,
  showSideNav,
  setShowSideNav,
}: DemoCustomerDashboardProps) {
  const [currSubPage, setCurrSubPage] = useState<string | null>(null);

  const handleSetSubPage = (page: string | null) => {
    setCurrSubPage(page);
  };

  const commonProps = {
    userType,
    currentPage,
    currentTab,
    setCurrentTab,
    subTab,
    setSubTab,
    currSubPage,
    setCurrSubPage: handleSetSubPage,
  };

  const customerHomeProps = {
    ...commonProps,
    application: undefined,
  };

  return (
    <Routes>
      <Route path="/" element={<CustomerHome {...customerHomeProps} />} />
      <Route path="home" element={<CustomerHome {...customerHomeProps} />} />
      <Route
        path="banking/*"
        element={<CustomerBankingOverview {...commonProps} />}
      />
      <Route
        path="finances/*"
        element={<CustomerFinancesOverview {...commonProps} />}
      />
      <Route path="assets/*" element={<CustomerAssets {...commonProps} />} />
      <Route path="drivers/*" element={<DriversHome {...commonProps} />} />
      <Route path="broker-network" element={<DemoBrokerNetwork />} />
      <Route
        path="settings/*"
        element={<CustomerSettings {...commonProps} />}
      />
    </Routes>
  );
}

export default DemoCustomerDashboard;
